import React, { useContext, useMemo, useEffect, useRef, useState } from "react";
// import EventSubscribers from './components/EventSubscribers';
import { Translator, Config } from "react-translator-component";
// import { getCDNImage } from './globals';

import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
// import HotelSettings from './components/HotelSettings';
import Home from "./screens/Home";
import Info from "./screens/Info";
import Services from "./screens/Services";
import Service from "./screens/Service";
import AddDevice from "./screens/AddDevice";
import Requests from "./screens/Requests";
import Notifications from "./screens/Notifications";
import NotificationsDetail from "./screens/NotificationsDetail";
// import RoomCategories from './screens/RoomCategories';
// import RoomCategoriesDetail from './screens/RoomCategoriesDetail';
// import Restaurants from './screens/Restaurants';
// import RestaurantsDetail from './screens/RestaurantsDetail';
// import Facilities from './screens/Facilities';
import CheckIn from "./screens/CheckIn";
import RequestDetail from "./screens/RequestDetail";
// import MeetingRoomsDetail from './screens/MeetingRoomsDetail';
// import FacilitiesDetail from './screens/FacilitiesDetail';
import Account from "./screens/Account";
import System from "./screens/System";
import Chat from "./screens/Chat";
import PrivateRoute from "./components/PrivateRoute";
// import Identify from './screens/Identify';
import Location from "./screens/Location";
// import Generic from './screens/Generic';
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Faqs from "./screens/Faqs";
import ServiceBookableDetail from "./screens/ServiceBookableDetail";
import UpsellingDetail from "./screens/UpsellingDetail";

import Amplify, { Auth } from "@aws-amplify/auth";

// import Amplify from "./services/realtime";

import awsconfig from "./aws-config";
// import MeetingRooms from './screens/MeetingRooms';
// import RestaurantReservation from './screens/RestaurantReservation';
// import HotelIdentify from './components/HotelIdentify';

import { HotelProvider, HotelContext, PWA_PREVIEW_SYNC_MESSAGE } from "./context/hotel";
import { UserProvider, UserContext } from "./context/user";
import { PersonProvider } from "./context/person";
import { WebPushProvider } from './context/webpush';
import { AlertProvider } from "./context/alert";
import { CheckInProvider } from "./context/checkin";
import { PaymentProvider } from "./context/payment";
import { KioskProvider } from "./context/kiosk";
import { Listing } from "./screens/Listing";
import { Detail } from "./screens/Detail";

import "./App.css";
import "./scss/app.scss";
import "./scss/kiosk.scss";

import Stay from "./screens/Stay";
import SmartLock from "./screens/SmartLock";
import CheckOut from "./screens/CheckOut";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './scss/custom-bootstrap.scss';
import InstallPrompt from './components/InstallPrompt';
import { Review } from "./screens/Review";
import { FoodMenu } from "./screens/FoodMenu";
import Generic from "./screens/Generic";

import UserSetings from "./screens/UserSettings";
import PaymentScreen from "./screens/PaymentScreen";
import PaymentScreenNew from "./screens/PaymentScreenNew";
import PublicBookableDetail from "./screens/PublicBookableDetail";
import PublicBookableList from "./screens/PublicBookableList";
import SmartLockWithAccess from "./screens/SmartLockWithAccess";
import ReservationDetail from "./screens/Public/ReservationDetail";
import Dashboard from "./screens/Public/Dashboard";
import PaymentResult from "./screens/PaymentResult";
import PublicRequestDetail from "./screens/Public/PublicRequestDetail";
import PublicChat from "./screens/Public/PublicChat";
import PublicCart from "./screens/Public/PublicCart";
import PublicLastRequest from "./screens/Public/PublicLastRequest";
import WelcomeKiosk from "./screens/Kiosk/Welcome/Main";
import KioskRouteGuard from "./components/KioskRouteGuard";
import LoginKiosk from "./screens/Kiosk/Login/Main";
import GlobalKioskEventListener from "./components/GlobalKioskEventListener";
import KioskInactivityManager from "./components/KioskInactivityManager";
import { KioskBodyClass } from "./components/KioskBodyClass";

Config.default = "en-US";
Config.list = {
  "en-US": {
    text: "English",
    icon: "./flags/en.svg", // https://zt12w.csb.app/flags/en.svg
    file: require("./locale/en"),
  },
  "es-ES": {
    text: 'Español',
    icon: './flags/es.svg', // https://zt12w.csb.app/flags/es.svg
    file: require('./locale/es')
  },
  "de": {
    text: 'Deutsch',
    icon: './flags/de.svg', // https://zt12w.csb.app/flags/de.svg
    file: require('./locale/de')
  },
  "it": {
    text: 'Italian',
    icon: './flags/it.svg', // https://zt12w.csb.app/flags/de.svg
    file: require('./locale/it')
  },
  "fr": {
    text: 'French',
    icon: './flags/fr.svg', // https://zt12w.csb.app/flags/de.svg
    file: require('./locale/fr')
  },
  "pt-BR": {
    text: 'Português',
    icon: './flags/pt-BR.svg', // https://zt12w.csb.app/flags/de.svg
    file: require('./locale/pt-BR')
  }
};

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

// initRealtime();

// Auth.currentUserInfo()
//       .then((res) => { console.log(res) })
//       .catch(() => { console.log('NO AUTH') });

//Auth.signIn('matias.s@ishareglonal.com', '$aBc12345$')

// Auth.signIn('m2smdq@gmail.com', '$aBc12345$')
// .then(cognitoUser  => {
//   console.log('successful sign in', cognitoUser)
// })
// .catch(err => console.log(err));

// Auth.signUp({
//   username : 'matias@atipiko.com',
//   password : 'MyCoolPassword1!',
//   attributes: {
//       email : 'matias@atipiko.com',
//       name : 'Matias Salinas',
//       picture : 'https://kottke.org/plus/misc/images/ai-faces-01.jpg'
//   }
// });\

// alert(window.location.host.split('.')[0]);

function App() {
  // let { url } = useRouteMatch();
  // const hotel = useSelector((state) => state.hotelReducer.data);
  // const { data : hotel } = useContext(HotelContext)

  // const codeHotel = hotel?.code

  // alert(codeHotel)

  // if (!hotel) {
  //   // window.location.host.split('.')[0]
  //   // return (<HotelIdentify />);
  // } else {
  //   let _host = "https://hotel.vicomanager.com";
  //   if (process.env.REACT_APP_APP_ENV === 'local') {
  //     _host = "http://localhost:3001";
  //   }
  //   if (process.env.REACT_APP_APP_ENV === 'dev') {
  //     _host = "https://hotel-dev.vicomanager.com";
  //   }

  //   document.title = hotel.name
  //   var myDynamicManifest = {
  //     "name": hotel.name,
  //     "short_name": hotel.name, // hotel.code,
  //     "description": "ViCo Manager for " + hotel.name,
  //     "start_url": _host + '/' + hotel.code + '/',
  //     // "start_url": "http://localhost:3001/",
  //     "display": "standalone",
  //     "theme_color": "#988460",
  //     "icons": [{
  //       "src": _host + "/maskable_icon_x48.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "48x48",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x72.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "72x72",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x96.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "96x96",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x128.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "128x128",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x144.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "144x144",
  //       "type": "image/png",HotelProvitings?.icon),
  //       "sizes": "192x192",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x384.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "384x384",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }, {
  //       "src": _host + "/maskable_icon_x512.png",
  //       // "src": getCDNImage(hotel.settings?.icon),
  //       "sizes": "512x512",
  //       "type": "image/png",
  //       "purpose": "maskable"
  //     }]
  //   };
  //   const stringManifest = JSON.stringify(myDynamicManifest);
  //   const blob = new Blob([stringManifest], {type: 'application/json'});
  //   const manifestURL = URL.createObjectURL(blob);
  //   document.querySelector('#client-manifest-placeholder').setAttribute('href', manifestURL);

  //   if (hotel.settings?.primaryColor) {
  //     document.documentElement.style.setProperty('--color-primary', hotel.settings.primaryColor)
  //   }
  //   if (hotel.settings?.secondaryColor) {
  //     document.documentElement.style.setProperty('--color-secondary', hotel.settings.secondaryColor)
  //   }

  //   let _home_logo_height = '80px';
  //   let _navbar_bottom_background = '#FFFFFF';
  //   let _navbar_bottom_color = '#333333';
  //   if (hotel.code === 'dev-hotel-matias') {
  //     _home_logo_height = '130px';
  //     _navbar_bottom_background = '#80358a';
  //     _navbar_bottom_color = '#FFFFFF';
  //   }
  //   if (hotel.code === 'mdq-sennac') {
  //     _home_logo_height = '300px';
  //     _navbar_bottom_background = '#333333';
  //     _navbar_bottom_color = '#FFFFFF';
  //   }
  //   if (hotel.code === 'mdq-brunetti') {
  //     _home_logo_height = '155px';
  //     _navbar_bottom_background = '#FFFFFF';
  //     _navbar_bottom_color = '#b48755';
  //   }
  //   if (hotel.code === 'mdq-10-de-septiembre') {
  //     _home_logo_height = '155px';
  //     _navbar_bottom_background = '#6f2d4e';
  //     _navbar_bottom_color = '#d1dd09';
  //   }
  //   if (hotel.code === 'test-1') {
  //     _home_logo_height = '120px';
  //     // _navbar_bottom_color = hotel.settings.primaryColor;
  //   }
  //   if (hotel.code === 'royal') {
  //     _home_logo_height = '130px';
  //     // _navbar_bottom_color = hotel.settings.primaryColor;
  //   }
  //   document.documentElement.style.setProperty('--home-logo-height', _home_logo_height)
  //   document.documentElement.style.setProperty('--navbar-bottom-background', _navbar_bottom_background)
  //   document.documentElement.style.setProperty('--navbar-bottom-color', _navbar_bottom_color)
  // }

  // document.documentElement.style.setProperty('--color-primary', "#FF9900")

  return (
    <HotelProvider>
      <KioskProvider>
        <KioskBodyClass />
        <HotelContext.Consumer>
          {({ data: hotel }) => {
            return (
              <BrowserRouter>
               <PreviewBridge />
               <PersonProvider>
                <UserProvider>
                  <CheckInProvider>
                    <WebPushProvider>
                      <Translator>
                        <InstallPrompt />
                        <GlobalKioskEventListener />
                        <KioskInactivityManager />
                        <AlertProvider>
                          <PaymentProvider>
                          {/* <TransitionGroup /*style={{ flex: 1, overflowY: 'scroll', position: 'relative' }}> */}
                          {/* <CSSTransition key={location.key} timeout={300} classNames='fade'> */}
                          <Routes>
                            <Route path="/" element={<Navigate
                              to="/home"
                              replace={true}
                            />} />
                            <Route path={`/${hotel?.code}`} element={<Navigate
                              to={`/${hotel?.code}/home`}
                              replace={true}
                            />} />
                            <Route path="/*" element={<KioskRouteGuard><BaseRoutes /></KioskRouteGuard>} />
                            <Route path={`/${hotel?.code}/*`} element={<KioskRouteGuard><BaseRoutes /></KioskRouteGuard>} />
                          </Routes>
                        </PaymentProvider>
                        {/* </CSSTransition> */}
                        {/* </TransitionGroup> */}
                      </AlertProvider>
                    </Translator>
                  </WebPushProvider>
                </CheckInProvider>
              </UserProvider>
              </PersonProvider>
            </BrowserRouter>

          );
        }}
      </HotelContext.Consumer>
      {/* </AlertProvider>
          </Translator>
        </CheckInProvider>
      </UserProvider> */}
      </KioskProvider>
    </HotelProvider>

  );
}

const PreviewBridge = () => {
  const { previewMode, previewParentOrigin, getUrlPath } = useContext(HotelContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingPreviewPath, setPendingPreviewPath] = useState(null);
  const lastRequestedPreviewPathRef = useRef(null);

  useEffect(() => {
    if (!previewMode || !previewParentOrigin) {
      return undefined;
    }

    const handlePreviewMessage = (event) => {
      if (event.origin !== previewParentOrigin) {
        return;
      }

      if (event.data?.type !== PWA_PREVIEW_SYNC_MESSAGE) {
        return;
      }

      const nextPreviewPath = event.data?.payload?.previewPath || "/home";
      if (lastRequestedPreviewPathRef.current === nextPreviewPath) {
        return;
      }

      lastRequestedPreviewPathRef.current = nextPreviewPath;
      setPendingPreviewPath(nextPreviewPath);
    };

    window.addEventListener("message", handlePreviewMessage);
    return () => window.removeEventListener("message", handlePreviewMessage);
  }, [previewMode, previewParentOrigin]);

  useEffect(() => {
    if (!previewMode || !pendingPreviewPath || !getUrlPath) {
      return;
    }

    const nextPath = getUrlPath(pendingPreviewPath);
    if (nextPath && nextPath !== location.pathname) {
      navigate(nextPath, { replace: true });
    }
    setPendingPreviewPath(null);
  }, [getUrlPath, location.pathname, navigate, pendingPreviewPath, previewMode]);

  return null;
}

const BaseRoutes = () => {
  return (<Routes>
    <Route exact path="home" element={<Home />} />
    <Route path={`checkin/info`} element={<Generic section="fast_checkin" />} />
    <Route path={`checkin/*`} element={<CheckIn />} />
    <Route path={`/kiosk/welcome-kiosk`} element={<WelcomeKiosk />} />
    <Route path={`/kiosk/login`} element={<LoginKiosk />} />
    <Route path={`r/*`}>
      <Route path={`:id/:redirect`} element={<CheckIn />} />
      <Route path={`:id`} element={<CheckIn />} />
    </Route>
    <Route path={`e/*`}>
      <Route path={`:externalCode`} element={<CheckIn />} />
    </Route>
    <Route exact path={`system`} element={<System />} />
    <Route exact path={`info`} element={<Info />} />
    <Route path={`location`} element={<Location />} />
    <Route path={`notifications/*`}>
      <Route index element={<Notifications />} />
      <Route
        path={`:id`}
        element={<NotificationsDetail />}
      />
    </Route>

    <Route path={`requests/*`}>
      <Route index element={<Requests />} />
      <Route path={`:id/*`}>
        <Route index element={<RequestDetail />} />
        <Route
          path={`messages`}
          element={<Chat entity={"requests"} />}
        />
      </Route>
    </Route>
    <Route
      exact
      path={`services/service_general`}
      element={<Service />}
    />
    <Route
      exact
      path="services"
      element={
        <PrivateRoute
          component={<Services />}
        />
      }
    />
    <Route
      path={`services/:service`}
      element={
        <PrivateRoute
          component={<Service />}
        />
      }
    />
    <Route
      path="stay"
      element={
        <PrivateRoute
          component={<Stay />}
        />
      }
    />
    <Route
      exact
      path={`account`}
      element={
        <PrivateRoute
          component={<Account />}
        />
      }
    />
    <Route
      path={`checkout`}
      element={
        <PrivateRoute
          component={<CheckOut />}
        />
      }
    />
    <Route
      path={`smartlock`}
      element={
        <PrivateRoute
          component={<SmartLock />}
        />
      }
    />
    <Route
      path={`smartlock-general`}
      element={<SmartLockWithAccess />}
    />

    <Route path={`add-device`} element={<AddDevice />} />
    <Route path={`faqs`} element={<Faqs />} />
    <Route
      exact
      path={`service_booking/:id`}
      element={
        <PrivateRoute
          component={<ServiceBookableDetail />}
        />
      }
    />

    <Route
      exact
      path={`upselling/:id`}
      element={
        <PrivateRoute
          component={<UpsellingDetail />}
        />
      }
    />

    <Route exact path={`:entity`} element={<DynamicEntityRoute />} />
    <Route
      exact
      path={`:entity/:id`}
      element={<Detail />}
    />
    <Route
      exact
      path={`:entity/:entityId/menu/:id`}
      element={<FoodMenu />}
    />
    <Route
      exact
      path={`reviews/:id`}
      element={<Review />}
    />
    <Route
      exact
      path={`restaurants/:restaurantId/menu/:id`}
      element={<FoodMenu />}
    />
    <Route
      exact
      path={`kids_club`}
      element={<Generic section="kids_club" />}
    />
    <Route
      exact
      path={`guests`}
      element={<Generic section="guests" />}
    />
    <Route
      exact
      path={`spa`}
      element={<Generic section="spa" />}
    />
    <Route
      exact
      path={`pool`}
      element={<Generic section="pool" />}
    />
    <Route
      exact
      path={`wellness`}
      element={<Generic section="wellness" />}
    />
    <Route
      exact
      path={`gift_cards`}
      element={<Generic section="gift_cards" />}
    />
    <Route
      exact
      path={`gift_cards_spa`}
      element={<Generic section="gift_cards_spa" />}
    />
    <Route
      exact
      path={`gift_cards_spa_harmony`}
      element={<Generic section="gift_cards_spa_harmony" />}
    />
    <Route
      exact
      path={`payments/:id`}
      element={<PaymentScreen />}
    />

    { /* PAGOS */}
    <Route
      exact
      path={`pay`}
      element={<PaymentScreenNew />}
    />
    <Route
      exact
      path={`pay/:id`}
      element={<PaymentScreenNew />}
    />

    <Route
      exact
      path={`public_cart`}
      element={<PublicCart />}
    />
    { /* PUBLIC */}
    <Route path={`public`}>
      <Route
        exact
        path={``}
        element={<Dashboard />}
      />
      <Route
        exact
        path={`booking/:id`}
        element={<PublicBookableDetail />}
      />
        <Route
        exact
        path={`booking/:id/:redirect`}
        element={<PublicBookableDetail />}
      />
       <Route
        exact
        path={`services`}
        element={<PublicBookableList />}
      />
      <Route
        exact
        path={`last-payment-request`}
        element={<PublicLastRequest />}
      />
    <Route path={`requests/*`}>
      <Route path={`:id/*`}>
        <Route index element={<PublicRequestDetail />} />
        <Route
          path={`messages`}
          element={<PublicChat />}
        />
      </Route>
    </Route>
    </Route>
    {/* END PUBLIC */}

    <Route
      exact
      path={`reservation/:id`}
      element={<ReservationDetail />}
    />
    <Route
      exact
      path={`public_home/:id`}
      element={<Dashboard />}
    />


    <Route
      exact
      path={`settings`}
      element={<UserSetings />}
    />


    { /* SUB PAGES */}
    <Route
      exact
      path={`club_luxury_full`}
      element={<Generic section="club_luxury_full" />}
    />
    <Route
      exact
      path={`club_luxury_classic`}
      element={<Generic section="club_luxury_classic" />}
    />
    <Route
      exact
      path={`kids_club_baby`}
      element={<Generic section="kids_club_baby" />}
    />
    <Route
      exact
      path={`kids_club_mini`}
      element={<Generic section="kids_club_mini" />}
    />
    <Route
      exact
      path={`kids_club_beach`}
      element={<Generic section="kids_club_beach" />}
    />
    <Route
      exact
      path={`laundry`}
      element={<Generic section="laundry" />}
    />
    <Route
      exact
      path={`minibar`}
      element={<Generic section="minibar" />}
    />
    <Route
      exact
      path={`room_service`}
      element={<Generic section="room_service" />}
    />
    <Route
      exact
      path={`club`}
      element={<Generic section="club" />}
    />


    <Route
      exact
      path={`kids_club_beach`}
      element={<Generic section="kids_club_beach" />}
    />

    <Route
      exact
      path={`arrival_guide`}
      element={<Generic section="arrival_guide" />}
    />
    <Route
      exact
      path={`g_1`}
      element={<Generic section="g_1" />}
    />
    <Route
      exact
      path={`g_2`}
      element={<Generic section="g_2" />}
    />
    <Route
      exact
      path={`g_3`}
      element={<Generic section="g_3" />}
    />
    <Route
      exact
      path={`g_4`}
      element={<Generic section="g_4" />}
    />
    <Route
      exact
      path={`g_5`}
      element={<Generic section="g_5" />}
    />

    <Route
      exact
      path={`cabin`}
      element={<Generic section="cabin" />}
    />

    <Route
      exact
      path={`cabin_rules`}
      element={<Generic section="cabin_rules" />}
    />
    <Route
      exact
      path={`saving_resources`}
      element={<Generic section="saving_resources" />}
    />
    <Route
      exact
      path={`cabin_wifi`}
      element={<Generic section="cabin_wifi" />}
    />

    <Route
      exact
      path={`cabin_checkout`}
      element={<Generic section="cabin_checkout" />}
    />
    <Route
      exact
      path={`packing_list`}
      element={<Generic section="packing_list" />}
    />
    <Route
      exact
      path={`lounge_bar`}
      element={<Generic section="lounge_bar" />}
    />
    <Route
      exact
      path={`lounge_bar_welcome_desk`}
      element={<Generic section="lounge_bar_welcome_desk" />}
    />
    <Route
      exact
      path={`lounge_bar_menu_lounge_bar`}
      element={<Generic section="lounge_bar_menu_lounge_bar" />}
    />
    <Route
      exact
      path={`lounge_bar_curaduria_musical`}
      element={<Generic section="lounge_bar_curaduria_musical" />}
    />

    <Route
      exact
      path={`emergency`}
      element={<Generic section="emergency" />}
    />

    <Route
      exact
      path={`menu/:id`}
      element={<FoodMenu />}
    />

    <Route
      exact
      path={`payment-result`}
      element={<PaymentResult />}
    />

  </Routes>);
}

const LISTING_SECTIONS = new Set([
  "rooms",
  "restaurants",
  "facilities",
  "meeting_rooms",
  "booking",
  "attractions",
]);

const DynamicEntityRoute = () => {
  const { entity } = useParams();
  const { sectionsByCode } = useContext(HotelContext);

  if (entity && sectionsByCode?.[entity] && !LISTING_SECTIONS.has(entity)) {
    return <Generic section={entity} />;
  }

  return <Listing />;
}

export default App;

/*
<Route path={`/${hotel?.code}/*`}>
                            <Route
                              index
                              element={
                                <Navigate
                                  to={`/${hotel?.code}/home`}
                                  replace={true}
                                />
                              }
                            />
                            <Route exact path={`home`} element={<Home />} />
                              // <Route exact path={`/${hotel.code}`} element={<Home />} />
                              // <Route exact path={`/${hotel.code}/`} element={<Home />} />
                              <Route path={`checkin/info`} element={<Generic section="fast_checkin" />} />
                              <Route path={`checkin/*`} element={<CheckIn />} />
                              <Route path={`r/*`}>
                                <Route path={`:id`} element={<CheckIn />} />
                              </Route>
                              <Route exact path={`system`} element={<System />} />
                              <Route exact path={`info`} element={<Info />} />
                              <Route path={`location`} element={<Location />} />
                              <Route path={`notifications/*`}>
                                <Route index element={<Notifications />} />
                                <Route
                                  path={`:id`}
                                  element={<NotificationsDetail />}
                                />
                              </Route>
  
                              
  
                              <Route path={`requests/*`}>
                                <Route index element={<Requests />} />
                                <Route path={`:id/*`}>
                                  <Route index element={<RequestDetail />} />
                                  <Route
                                    path={`messages`}
                                    element={<Chat entity={"requests"} />}
                                  />
                                </Route>
                              </Route>
                              <Route
                                exact
                                path={`services/service_general`}
                                element={<Service />}
                              />
                              <Route
                                exact
                                path="services"
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<Services />}
                                  />
                                }
                              />
                              <Route
                                path={`services/:service`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<Service />}
                                  />
                                }
                              />
                              <Route
                                path="stay"
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<Stay />}
                                  />
                                }
                              />
                              <Route
                                exact
                                path={`account`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<Account />}
                                  />
                                }
                              />
                              <Route
                                path={`checkout`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<CheckOut />}
                                  />
                                }
                              />
                              <Route
                                path={`smartlock`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<SmartLock />}
                                  />
                                }
                              />
  
                              <Route path={`add-device`} element={<AddDevice />} />
                              <Route path={`faqs`} element={<Faqs />} />
                              <Route
                                exact
                                path={`service_booking/:id`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<ServiceBookableDetail />}
                                  />
                                }
                              />
  
                              <Route
                                exact
                                path={`upselling/:id`}
                                element={
                                  <PrivateRoute
                                    hotel={hotel}
                                    component={<UpsellingDetail />}
                                  />
                                }
                              />
  
                              // <Route path={`/${hotel.code}/booking`}>
                              //     <Generic section="booking" />
                              //   </Route>
                                
                              //   <Route path={`/${hotel.code}/restaurant_reservation`} element={<RestaurantReservation />} />
  
                                
                              //   <Route path="/request_detail" element={<RequestDetail />} />
                              //   <Route path="/facilities_detail" element={<FacilitiesDetail />} />
  
                              <Route exact path={`:entity`} element={<Listing />} />
                              <Route
                                exact
                                path={`:entity/:id`}
                                element={<Detail />}
                              />
                              <Route
                                exact
                                path={`reviews/:id`}
                                element={<Review />}
                              />
                              <Route
                                exact
                                path={`restaurants/:restaurantId/menu/:id`}
                                element={<FoodMenu />}
                              />
                              <Route
                                exact
                                path={`kids_club`}
                                element={<Generic section="kids_club" />}
                              />
                              <Route
                                exact
                                path={`spa`}
                                element={<Generic section="spa" />}
                              />
                              <Route
                                exact
                                path={`pool`}
                                element={<Generic section="pool" />}
                              />
                              <Route
                                exact
                                path={`payments/:id`}
                                element={<PaymentScreen />}
                              />
                              <Route
                                exact
                                path={`settings`}
                                element={<UserSetings />}
                              />
                            </Route>
*/